/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { HighlightOptionSchema } from './highlightOptionSchema';
import type { PowerFilterOptionSchema } from './powerFilterOptionSchema';

export interface FilterOptionsResponseSchema {
  job_title_levels: string[];
  job_title_roles: string[];
  degrees: string[];
  company_sizes: string[];
  funding_stages: string[];
  power_filters: PowerFilterOptionSchema[];
  highlights: HighlightOptionSchema[];
  scopes: string[];
}
